<script lang="ts">
import {computed, defineComponent, ref} from '@vue/composition-api'

import {mapGetters} from '@/utils/map-store'

export default defineComponent({
  name: 'Landbot',
  setup(props, {root}) {
    const {getBranch: branch, getCapabilities: capabilities} = mapGetters(root.$store.getters)

    const show = ref(false)

    const instanceLoaded = ref(false)
    const zoomInTransition = {
      enterActiveClass: 'animated faster transform-origin fadeIn zoomIn',
      leaveActiveClass: 'animated faster transform-origin fadeOut zoomOut',
    }

    const isChatbotPermitted = computed(() => {
      return capabilities.value?.chatbot?.mode === 'FULL'
    })

    function fetchLandbot() {
      if (instanceLoaded.value) return
      // @ts-ignore
      // eslint-disable-next-line no-undef,@typescript-eslint/no-unused-vars
      const landbot = new Landbot.Container({
        configUrl: getConfigUrl(),
        container: '#landbot-anchor',
      })

      if (landbot) {
        instanceLoaded.value = true
      }
    }

    function handleClick() {
      show.value = false
    }

    function getConfigUrl() {
      switch (branch.value) {
        case 'ES':
          return process.env.VUE_APP_LANDBOT_CONFIG_URL_ES
        case 'PT':
          return process.env.VUE_APP_LANDBOT_CONFIG_URL_PT
        default:
          return process.env.VUE_APP_LANDBOT_CONFIG_URL_EN
      }
    }

    function toggleLandbot() {
      show.value = !show.value
    }

    return {
      show,
      zoomInTransition,
      isChatbotPermitted,
      fetchLandbot,
      handleClick,
      toggleLandbot,
    }
  },
})
</script>
<template>
  <div class="landbot-wrapper" v-if="isChatbotPermitted">
    <transition v-bind="zoomInTransition">
      <div v-show="show" class="landbot-container">
        <button type="button" class="close" @click="handleClick()">
          <v-icon color="primary">fa-solid fa-xmark-large</v-icon>
        </button>
        <div id="landbot-anchor"></div>
      </div>
    </transition>
    <portal to="landbot-target">
      <div class="landbot-action" @mouseenter="fetchLandbot()">
        <button type="button" class="landbot-button" @click="toggleLandbot()">
          <img src="/images/chatbot.svg" alt="Chatbot" />
        </button>
      </div>
    </portal>
  </div>
</template>
<style lang="scss">
.faster {
  animation-duration: 0.3s !important;
}
.transform-origin {
  transform-origin: bottom right !important;
}
.landbot-target {
  .landbot-action {
    background-color: #dc182d;
    position: fixed !important;
    bottom: 18px;
    right: 18px;
    width: 61px;
    height: 61px;
    border-radius: 31px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.25));
    transition: transform 0.1s ease-in-out;

    &:hover {
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.9);
    }
  }
  .landbot-button {
    appearance: none;
    display: flex !important;
    justify-content: center;
    margin: 0;
    padding: 0 !important;
    align-items: center;
    cursor: pointer;
    font-size: 36px;
    border-radius: 8px;
    z-index: 1;
    background: transparent;
    border: none;
    color: white;
    height: auto !important;
    line-height: normal !important;
    position: static !important;
    font-family: inherit !important;
    text-transform: none !important;
    letter-spacing: normal !important;

    > i {
      font-size: 36px;
      margin-top: 4px;
      transform: rotateY(180deg);
    }
  }
}
.landbot-container {
  width: 400px;
  height: 75vh;
  position: absolute;
  bottom: 100px;
  right: 18px;
  /* z-index: 100; */
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.4));
  border-radius: 8px;
  overflow: hidden;

  #landbot-anchor {
    width: 100%;
    height: 100%;
  }

  .close {
    width: 40px;
    appearance: none;
    position: absolute !important;
    top: calc(78px * 0.5);
    right: 24px;
    cursor: pointer;
    font-size: 24px;
    border-radius: 4px;
    z-index: 1;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    transition: background-color 0.2s ease-in-out;
    padding: 0 !important;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 4px;
    }
  }
}
</style>
